module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "landing-works"
  }, [_c('section', {
    staticClass: "content-works"
  }, [_c('div', {
    staticClass: "inside"
  }, [(_vm.pageInclusionCaseStudies.header_text) ? _c('div', {
    staticClass: "text-center headline-container"
  }, [_c('h1', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport",
      value: ({}),
      expression: "{}"
    }],
    staticClass: "headline"
  }, [_vm._v("\n          " + _vm._s(_vm.pageInclusionCaseStudies.header_text.value) + "\n        ")]), _vm._v(" "), (_vm.pageInclusionCaseStudies.intro_paragraph) ? _c('p', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport",
      value: ({}),
      expression: "{}"
    }],
    staticClass: "intro_text"
  }, [_vm._v("\n          " + _vm._s(_vm.pageInclusionCaseStudies.intro_paragraph.value) + "\n        ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('boxes-wrapper', {
    attrs: {
      "boxes": _vm.caseStudies,
      "boxlimit": 8
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d2ce4b7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/landings/InclusionCaseStudies.vue
// module id = 1520
// module chunks = 0